import React, {useState, useEffect} from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import styles from './Layout.module.css'
import { Helmet } from "react-helmet"
import { useCycle } from 'framer-motion' 
import SideDrawer from '../SideDrawer/SideDrawer'



export default function Layout({ children }) {
  const [isOpen, toggleOpen] = useCycle(false, true)
  const [navScroll, setNavScroll] = useState(false)
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

const handleScroll = (e) => {
  let scroll = window.scrollY
  scroll > 3 ? setNavScroll(true) : setNavScroll(false)
}
    return (
        <div id="top" className="layout">
          <Helmet>
          <meta charSet="utf-8" />
          <title>Эрчим хүчний аудит</title>
          </Helmet>
            <Navbar navScroll={navScroll} toggleDrawer={() => toggleOpen()}/>
            <SideDrawer isShown={isOpen}/>
                <div className={styles.container}>
                    {children}
                </div>
            <Footer/>
        </div>
    )
}
